"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockUIDefaultName = "block-ui-main";



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-block-ui/dist/lib/constants/block-ui-default-name.constant.js
// module id = ./node_modules/ng-block-ui/dist/lib/constants/block-ui-default-name.constant.js
// module chunks = vendor